import { css } from '@emotion/react'

export const fileWrapper = css({
  alignItems: 'center',
  backgroundColor: '#e6ebf0',
  display: 'flex',
  height: 60,
  justifyContent: 'space-between',
  padding: '0 16px',
  width: '100%',
})

export const fileSectionWrapper = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-start',
})
